import './App.css';
import IndexRoutes from './Routes/Index';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './Utils/Theme';

import { MsalProvider } from "@azure/msal-react"
import { ToastContainer } from 'react-toastify';


function App({ msalInstance }) {
  return (
    <MsalProvider instance={msalInstance}>
      <ChakraProvider theme={theme}>

        <IndexRoutes />
        <ToastContainer/>
      </ChakraProvider>
    </MsalProvider>

  );
}

export default App;
